import { MessageCircle } from "lucide-react";
import { motion } from "framer-motion";

export default function WhatsAppButton() {
  return (
    <motion.a
      data-testid="whatsapp-float-button"
      href="https://wa.me/919741106724?text=Hi%20SK%20Media%20Events%2C%20I%27d%20like%20to%20plan%20an%20event."
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      initial={{ opacity: 0, scale: 0 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 2.2, type: "spring", stiffness: 200, damping: 14 }}
      className="fixed bottom-6 right-6 z-[70] group"
    >
      <span className="absolute inset-0 rounded-full bg-[#d4af37] animate-ping opacity-20" />
      <span className="relative flex items-center justify-center w-14 h-14 rounded-full bg-gradient-to-br from-[#f3e5ab] via-[#d4af37] to-[#aa771c] text-[#09090b] shadow-[0_8px_30px_rgba(212,175,55,0.4)] group-hover:scale-110 transition-transform duration-300">
        <MessageCircle size={24} fill="currentColor" />
      </span>
      <span className="absolute right-full mr-4 top-1/2 -translate-y-1/2 whitespace-nowrap bg-[#121215] border border-[rgba(212,175,55,0.35)] text-[#f3e5ab] text-xs tracking-wider px-4 py-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
        Chat with us
      </span>
    </motion.a>
  );
}
